import { render, staticRenderFns } from "./SetupFactorAuth.vue?vue&type=template&id=49f481e4&"
import script from "./SetupFactorAuth.vue?vue&type=script&lang=ts&"
export * from "./SetupFactorAuth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports